<div class="backgroundImage">
    <app-header login= 'yes'></app-header>
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            </div>


            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="sin-in-page-top">
                    <div class="card-wrapper">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div style="min-height: 500px;">
                                <app-sub-header title="About Us"></app-sub-header>


                                <div class="row">
                                    <div class="col-md-12 ">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">Introduction Message </label>
                                            <textarea maxlength="120" class="form-control" formControlName="welcomeMessage"
                                                placeholder="Introduction Message" rows="5"
                                                [ngClass]="{ 'is-invalid': submitted && f.welcomeMessage.errors }">
                                                </textarea>
                                            <div style="text-align: right;">
                                                <p style="margin-bottom: -1rem;" class="small color">
                                                    {{f.welcomeMessage.value?.length || 0}}/120</p>
                                            </div>



                                            <div *ngIf="submitted && f.welcomeMessage.errors" class="invalid-feedback">
                                                <div *ngIf="f.welcomeMessage.errors.required">{{errorMessage}}</div>


                                            </div>


                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-12 ">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">General Information </label>
                                            <textarea maxlength="1000" class="form-control" formControlName="shortBio"
                                                placeholder="General Information" rows="5"
                                                [ngClass]="{ 'is-invalid': submitted && f.shortBio.errors }">
                                                </textarea>
                                            <div style="text-align: right;">
                                                <p style="margin-bottom: -1rem;" class="small color">
                                                    {{f.shortBio.value?.length || 0}}/1000</p>
                                            </div>



                                            <div *ngIf="submitted && f.shortBio.errors" class="invalid-feedback">
                                                <div *ngIf="f.shortBio.errors.required">{{errorMessage}}</div>


                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>

                            <br>
                            <button type="submit" class="btn btn-lg btn-block btn-primary">Add</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>